import { HubAgendaModel } from "./hub-agenda-model";
import { HubAssinaturaModel } from "./hub-assinatura-model";

let hubAgendaModel = null;
let hubAssinaturaModel = null;

export function modelHubAgenda() {
  if (!hubAgendaModel) hubAgendaModel = new HubAgendaModel();
  return hubAgendaModel;
}

export function modelHubAssinatura() {
  if (!hubAssinaturaModel) hubAssinaturaModel = new HubAssinaturaModel();
  return hubAssinaturaModel;
}
